import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var StorageError = /*#__PURE__*/function (_Error) {
  _inherits(StorageError, _Error);
  function StorageError(message) {
    var _this;
    _classCallCheck(this, StorageError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StorageError).call(this, message));
    _this.__isStorageError = true;
    _this.name = 'StorageError';
    return _this;
  }
  return StorageError;
}(_wrapNativeSuper(Error));
export function isStorageError(error) {
  return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
export var StorageApiError = /*#__PURE__*/function (_StorageError) {
  _inherits(StorageApiError, _StorageError);
  function StorageApiError(message, status) {
    var _this2;
    _classCallCheck(this, StorageApiError);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(StorageApiError).call(this, message));
    _this2.name = 'StorageApiError';
    _this2.status = status;
    return _this2;
  }
  _createClass(StorageApiError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        status: this.status
      };
    }
  }]);
  return StorageApiError;
}(StorageError);
export var StorageUnknownError = /*#__PURE__*/function (_StorageError2) {
  _inherits(StorageUnknownError, _StorageError2);
  function StorageUnknownError(message, originalError) {
    var _this3;
    _classCallCheck(this, StorageUnknownError);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(StorageUnknownError).call(this, message));
    _this3.name = 'StorageUnknownError';
    _this3.originalError = originalError;
    return _this3;
  }
  return StorageUnknownError;
}(StorageError);